function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      & ", " {\n        display: none;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    min-height: 300px;\n    height: 100%;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { useContext, useState } from 'react';
import styled, { css, ThemeContext, ThemeProvider } from 'styled-components';
import { EnumProductStates } from "./types";
import { defaultProductCardTheme } from "./theme";
import { PRODUCT_TEST_ID } from "./constants";
import Flex from "../Grid/Flex";
import { mediaSmDown, mediaSmUp } from "../../theme/helpers/media";
import { addStyleIfPropTruly } from "../../utils/styledComponents";
import GridCardProductInfo from "./components/GridCardProductInfo";
import { hoverStyles } from "./styled";
var TopButtonsWrapper = styled.div.withConfig({
  displayName: "GridCard__TopButtonsWrapper",
  componentId: "sc-1sskodl-0"
})(["position:absolute;", ""], function (_ref) {
  var fullImage = _ref.fullImage;
  return css(["top:", ";left:", ";right:", ";"], fullImage ? '7px' : '0px', fullImage ? '7px' : '0px', fullImage ? '7px' : '0px');
});
var MobileHideableWrapper = styled(Flex).attrs({
  column: true,
  between: true
}).withConfig({
  displayName: "GridCard__MobileHideableWrapper",
  componentId: "sc-1sskodl-1"
})(["", ""], mediaSmDown(_templateObject(), addStyleIfPropTruly('hide', 'display: none;')));
var Container = styled(Flex).attrs({
  column: true,
  stretch: true
}).withConfig({
  displayName: "GridCard__Container",
  componentId: "sc-1sskodl-2"
})(["background-color:#fff;display:flex;flex-direction:column;justify-content:stretch;position:relative;", ";&:active{background:none;}&:hover,&:focus{", "}", " ", ";", " ", ""], mediaSmUp(_templateObject2()), hoverStyles, function (_ref2) {
  var focused = _ref2.focused;
  return focused && hoverStyles;
}, function (_ref3) {
  var focused = _ref3.focused;
  return focused && css(["z-index:2;&:hover,&:focus{z-index:2;}"]);
}, function (_ref4) {
  var active = _ref4.active;
  return active && css(["&:hover,&:focus{z-index:2;}"]);
}, function (_ref5) {
  var showMobileInfo = _ref5.showMobileInfo;
  return !showMobileInfo && css(["", ""], mediaSmDown(_templateObject3(), MobileHideableWrapper));
});

var GridCard = function GridCard(_ref6) {
  var product = _ref6.product,
      className = _ref6.className,
      state = _ref6.state,
      renderLinkWrapper = _ref6.renderLinkWrapper,
      _ref6$fullImage = _ref6.fullImage,
      fullImage = _ref6$fullImage === void 0 ? false : _ref6$fullImage,
      renderTopSlot = _ref6.renderTopSlot,
      renderBottomSlot = _ref6.renderBottomSlot,
      isKomus = _ref6.isKomus;
  var themeContext = useContext(ThemeContext);

  var resultTheme = _objectSpread({}, defaultProductCardTheme, {}, themeContext);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var isProductInCart = state === EnumProductStates.inBasket;
  var isNotAvailable = state === EnumProductStates.notAvailable || !product.available;
  return React.createElement(ThemeProvider, {
    theme: resultTheme
  }, React.createElement(Container, {
    "data-testid": PRODUCT_TEST_ID,
    tabIndex: 0,
    className: className,
    active: isProductInCart,
    disabled: isNotAvailable,
    showMobileInfo: state === EnumProductStates.toBasket,
    focused: focused,
    onBlur: function onBlur() {
      setFocused(false);
    }
  }, React.createElement(TopButtonsWrapper, {
    fullImage: fullImage
  }, renderTopSlot && renderTopSlot()), renderLinkWrapper ? renderLinkWrapper(React.createElement(GridCardProductInfo, {
    fullImage: fullImage,
    product: product,
    state: state,
    isKomus: isKomus
  })) : React.createElement(GridCardProductInfo, {
    fullImage: fullImage,
    product: product,
    state: state,
    isKomus: isKomus
  }), React.createElement(React.Fragment, null, renderBottomSlot && renderBottomSlot())));
};

export default GridCard;